import PropTypes from "prop-types";

/* MATERIAL UI */
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, useMediaQuery } from "@mui/material";

/* THIRD PARTY */
import PerfectScrollbar from "react-perfect-scrollbar";
import { BrowserView, MobileView } from "react-device-detect";

/* PROJECT IMPORTS */
import { drawerWidth } from "store/constants";
import LogoSection from "../LogoSection";
import MenuList from "./MenuList";

const Sidebar = ({ drawerOpen, drawerToggle, window }: any) => {
  const theme = useTheme() as any;
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));

  const drawer = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 2,
          marginTop: matchUpMd ? 0 : 3,
        }}
      >
        <LogoSection />
      </Box>

      <BrowserView style={{ marginTop: 15, height: `calc(100% - 140px)` }}>
        <PerfectScrollbar
          component="div"
          style={{
            paddingLeft: 5,
            paddingRight: 5,
            height: `calc(100% - 10px)`,
            overflow: "hidden scroll",
          }}
          className="side-bar-scroll"
        >
          <MenuList />
        </PerfectScrollbar>
      </BrowserView>
      
      <MobileView>
        <Box
          sx={{
            px: 2,
            height: "auto",
          }}
        >
          <MenuList />
        </Box>
      </MobileView>
    </>
  );

  const container =
    window !== undefined ? () => window.document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: matchUpMd ? drawerWidth : "auto",
        background: drawerOpen && theme.palette.dominos.dominos_blue,
      }}
      aria-label="side-nav"
    >
      <Drawer
        container={container}
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            background: theme.palette.dominos.dominos_blue,
            color: theme.palette.text.primary,
            borderRight: "none",
            [theme.breakpoints.up("md")]: {
              top: "48px",
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;
